export function GET_FILE_NAME_AND_REMOVE_EXTENSION(fileName: string): string {
    const lastDotIndex = fileName?.lastIndexOf('.');
    if (lastDotIndex !== -1 && lastDotIndex !== 0) {
        return fileName?.substring(0, lastDotIndex);
    }
    return fileName;
}